<template>
  <div class="main-page">
    <div class="page-header">
      <div class="level-button" v-if="isLoaded">
        <button class="btn-prev" v-on:click="nextToLevel(task.level-1)"
                :disabled="task.level <= 1"><i
          class="fas fa-angle-left"></i>
        </button>
        <span>Level {{task.level}} of {{levelsCount}}</span>
        <button class="btn-next" v-on:click="nextToLevel(task.level+1)"
                :disabled="task.level >= this.levelsCount"><i
          class="fas fa-angle-right"></i>
        </button>
      </div>

      <h3 class="page-header_title">
        <slot v-if="isLoaded">{{course.name}}</slot>
        <skeleton-box v-else width="270px" height="29px"></skeleton-box>
      </h3>

      <span class="page-header_description">
          <slot v-if="isLoaded">Level {{task.level}} - {{task.name}}</slot>
          <skeleton-box v-else width="160px" height="16px"></skeleton-box>
        </span>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
    import {GET_TASK, TASK_REQUEST, USER_TASK_START} from "../store/actions/task";
    import {TaskFilter} from "../models/taskFilter";
    import SkeletonBox from "../components/SkeletonBox";

    export default {
        name: "Task",
        components: {SkeletonBox},
        props: ['courseId', 'id'],
        data() {
            return {
                task: {
                    name: '',
                    level: ''
                },
                course: {
                    name: '',
                    description: ''
                },
                levelsCount: 0
            }
        },
        created() {
            this.$store.dispatch(TASK_REQUEST, new TaskFilter({
                courseId: this.courseId
            })).then(tasks => {
                this.prepareData(tasks, this.courseId);
            });

            this.prepareData(this.getTasksByCourse(this.$store.getters.getTasks));
        },
        methods: {
            prepareData(tasks) {
                if (tasks.length <= 0) return;

                Math.max.apply(Math, tasks.map((task) => {
                    this.levelsCount = task.level;
                }));

                if (tasks.find(task => task.id === this.id) !== undefined) {
                    this.task = tasks.find(task => task.id === this.id);
                    this.task.course.then(courseData => this.course = courseData);
                }
            },
            getTasksByCourse(tasks) {
                return tasks.filter(task => task.courseId === this.courseId);
            },
            nextToLevel(level) {
                let nextTask = this.$store.getters.getTasks.filter(t =>
                    t.courseId === this.task.courseId &&
                    t.level === level)[0];

                if (nextTask !== undefined)
                    this.$router.push({
                        name: 'TaskTheory',
                        params: {
                            courseId: this.courseId,
                            id: nextTask.id
                        }
                    });
            }
        },
        watch: {
            $route(to, from) {
                this.prepareData(this.$store.getters.getTasks);
            }
        },
        computed: {
            isLoaded() {
              return this.course.name && this.task.level;
            }
        }
    }
</script>

<style scoped>

</style>
